class ProductVariationSwatch extends HTMLAnchorElement {
  static abortController = null;

  constructor() {
    super();

    this.loader = this.closest('section').querySelector('.loading__spinner')
    this.addEventListener('click', this.handleClick);
  }

  async handleClick(event) {
    event.preventDefault();

    // Enable loading
    this.loader.classList.remove('hidden');

    // Abort any ongoing request if there is one
    if (ProductVariationSwatch.abortController) {
      ProductVariationSwatch.abortController.abort();
    }

    // Create a new AbortController for the current request
    const controller = new AbortController();
    ProductVariationSwatch.abortController = controller;  // Store the current controller

    const sectionId = this.closest('section').id;
    const url = `${this.href}?section_id=${sectionId}`;

    try {
      const response = await fetch(url, { signal: controller.signal });
      
      if (!response.ok) 
        throw new Error('Failed to fetch content'), window.location.href = this.href;

      const newMarkup = await response.text();
      const newSectionContent = new DOMParser().parseFromString(newMarkup, 'text/html').querySelector('.js-product-content');

      if (newSectionContent) 
        this.closest('.js-product-content').replaceWith(newSectionContent);
    } catch (error) {
      console.error('Error:', error);
    }

    // Disable loading
    this.loader.classList.add('hidden');
  }
}

customElements.define('product-variation-swatch', ProductVariationSwatch, { extends: 'a' });
